import {Trans} from "next-i18next";
import Link from "next/link";
import {useState} from "react";
import Checklist from "./Checklist";

interface AgbChecklistProps {
	onChange: (passed: boolean) => void
}

function AgbChecklist(props: AgbChecklistProps) {

	const [accepted, setAccepted] = useState(false);
	return (<Checklist
		items={[
			{
				id: 1,
				customLabel: (
					<span className={`text-lg block text-leo-button-gray font-bold`}>
                <Trans
	                i18nKey="pages.verkaufsanfrage.agreeToPrivacyTerms"
	                components={{
		                privacyLink: (
			                <Link
				                href="/datenschutz"
				                className="text-leo-brown underline"
				                target="_blank"
			                />
		                ),
		                termsLink: (
			                <Link
				                href="/agb"
				                className="text-leo-brown underline"
				                target="_blank"
			                />
		                )
	                }}
                />
                *
              </span>
				),
				defaultChecked: false
			}
		]}
		onChange={(id, checked) => {
			if (id === 1) {
				setAccepted(checked);
				props.onChange(checked);
			}
		}}
	/>);
}

export default AgbChecklist;